export const getCurrentSalonId = (user) => {
  const rawId =
    user?.salon_id ??
    (typeof window !== "undefined" ? window.localStorage.getItem("salon_id") : null);
  if (rawId === null || rawId === undefined || rawId === "") {
    return null;
  }
  const parsed = Number(rawId);
  return Number.isFinite(parsed) ? parsed : null;
};

export const getCurrentSalonName = (user) => {
  const name =
    user?.salon_name ??
    (typeof window !== "undefined" ? window.localStorage.getItem("salon_name") : null);
  return name || "";
};

export const getCurrentSalon = (user) => ({
  id: getCurrentSalonId(user),
  name: getCurrentSalonName(user),
});
